import { createTheme, responsiveFontSizes, adaptV4Theme } from '@mui/material/styles';

const isRenault = process.env.REACT_APP_BRAND === 'renault'

const RENAULT_THEME = {
    palette: {
        yellow: '#EFDF00',
        hover_yellow: '#A79C00',
        hover_yellow_light: '#F8EB4C'
    },
    typography: {
        fontFamily: 'NouvelR-Regular'
    }
}
const DACIA_THEME = {
    palette: {
        main: '#646b52',
        hover_main: '#4e5844',
        orange: '#FF671B'
    },
    typography: {
        fontFamily: 'DaciaBlock-Regular'
        // Read-Regular_V3000
    }
}


function getTheme(isDark) {
    const theme = createTheme(adaptV4Theme({
        palette: {
            mode: isDark ? 'dark' : 'light',
            primary: {
                main: isRenault ? RENAULT_THEME.palette.yellow : DACIA_THEME.palette.main,
            },
            secondary: {
                main: isDark ? (isRenault ? RENAULT_THEME.palette.yellow : DACIA_THEME.palette.main) : (isRenault ? '#1f2532' : '#4e5844'),
                //'#1f2532'
                //4e5844
            },
            blue: {
                main: '#1f2532',
            },
            common: {
                transparent: '#ffffff00',
            },
            shape: {
                borderRadius: 4
            },
            success: {
                main: isRenault ? RENAULT_THEME.palette.yellow : DACIA_THEME.palette.main,
            }
        },
        typography: {
            fontFamily: isRenault ? RENAULT_THEME.typography.fontFamily : DACIA_THEME.typography.fontFamily
        },
        overrides: {
            MuiButton: {
                root: {
                    textTransform: 'none',
                    fontSize: '1.25em'
                    // borderRadius: 0
                },
                // containedSecondary: {
                //     '&:hover': {
                //         backgroundColor: '#000',
                //     }
                // },
            },
            MuiOutlinedInput: {
                root: {
                    // borderRadius: 0
                }
            }
        },
    }))
    // return theme
    return responsiveFontSizes(theme)
}


export default getTheme